<div class="tabs" #tabContainer>
  @for (item of items; track $index) {
  <button
    class="tab"
    [class.active]="item.key === active()"
    (click)="onTab(item.key, item.path)"
  >
    <span
      class="tab-icon"
      [style.--icon-url]="'url(' + item.icon + ')'"
      aria-hidden="true"
    ></span>
    <span class="label">{{ item.label }}</span>
  </button>
  }
</div>
